import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaYoutube, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4">
          {/* About */}
          <Col md={4}>
            <h5 className="fw-bold text-white mb-3">Mbaitu USA</h5>
            <p>
              A community of Kamba families in Texas, united to support one another
              through bereavement aid, cultural events, and shared growth.
            </p>
          </Col>

          {/* Quick Links */}
          <Col md={4}>
            <h5 className="fw-bold text-white mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col md={4}>
            <h5 className="fw-bold text-white mb-3">Contact</h5>
            <p className="mb-1">
              <FaEnvelope className="me-2" />
              <a href="mailto:info@mbaituusa.org">
                info@mbaituusa.org
              </a>
            </p>
            <p>
              <FaMapMarkerAlt className="me-2" />
              Dallas-Fort Worth, Texas
            </p>
          </Col>
        </Row>

        {/* Social + Copyright */}
        <hr className="footer-divider" />
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="d-flex gap-3 mb-2 mb-md-0">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social"><FaFacebook size={18} /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer-social"><FaInstagram size={18} /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="footer-social"><FaYoutube size={18} /></a>
          </div>
          <small>&copy; {new Date().getFullYear()} Mbaitu USA. All rights reserved.</small>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
